import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenAudit } from '@/components/screens/audit-screen';
import { useApplications } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function AuditPage() {
  const sp = useScreenProps();
  const {
    data: apps,
    isLoading,
    isError,
    error,
    refetch,
    isFetching,
    dataUpdatedAt,
  } = useApplications();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta a false, mas `apps` segue undefined).
  if (isError && !apps) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="audit"
        role="admin"
        title="Auditoria 2026"
        subtitle="Cobertura documental e evidências para o relatório de auditoria"
      />
    );
  }
  if (isLoading || !apps) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenAudit
        {...sp}
        apps={apps}
        onRefresh={() => void refetch()}
        refreshing={isFetching}
        dataUpdatedAt={dataUpdatedAt}
      />
    </div>
  );
}
